<template>
  <b-card no-body>
    <b-card-body>
      <div class="chart-title text-center mb-2">
        {{ titleText }}
      </div>
      <vue-apex-charts
        ref="barChart"
        type="bar"
        height="350"
        :options="columChart.chartOptions"
        :series="columChart.series"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody, BCardHeader, BCardTitle } from "bootstrap-vue";
import VueApexCharts from "vue-apexcharts";
import flatPickr from "vue-flatpickr-component";
// import apexChatData from "./apexChartData";
import * as apiDashboard from "@/store/api/dashboard/index.js";
import * as userData from "@/auth/localStorageUtils.js";
import chartColor from "./ChartColor";

// const chartColors = {
//   column: {
//     series1: "#826af9",
//     series2: "#d2b0ff",
//     bg: "#f8d3ff",
//   },
//   success: {
//     shade_100: "#7eefc7",
//     shade_200: "#06774f",
//   },
//   donut: {
//     series1: "#ffe700",
//     series2: "#00d4bd",
//     series3: "#826bf8",
//     series4: "#2b9bf4",
//     series5: "#FFA1A1",
//   },
//   area: {
//     series3: "#a4f8cd",
//     series2: "#60f2ca",
//     series1: "#2bdac7",
//   },
// };

export default {
  components: {
    BCard,
    BCardBody,
    BCardHeader,
    VueApexCharts,
    flatPickr,
    BCardTitle,
  },
  props: {
    issueName: {
      type: String,
      default: "",
    },
    // year: {
    //   type: Number,
    //   default: new Date().getFullYear(),
    // },
    // departmentId: {
    //   type: String,
    //   default: "",
    // },
    titleText: {
      type: String,
      default: "",
    },
    filter: {
      type: Object,
      default: () => ({
        year: new Date().getFullYear().toString(),
        yearEnd: new Date().getFullYear().toString(),
        startDate: "",
        endDate: "",
        userId: userData.userId(),
        departmentId: userData.departmentId(),
      }),
      // default: {
      //   year: new Date().getFullYear().toString(),
      //   startDate: "",
      //   endDate: "",
      //   userId: userData.userId(),
      //   departmentId: userData.departmentId(),
      // },
    },
    // xaxisCategories: {
    //   type: Array,
    //   default: () => [
    //     "ม.ค.",
    //     "ก.พ.",
    //     "มี.ค.",
    //     "เม.ย.",
    //     "พ.ค.",
    //     "มิ.ย.",
    //     "ก.ค.",
    //     "ส.ค.",
    //     "ก.ย.",
    //     "ต.ค.",
    //     "พ.ย.",
    //     "ธ.ค.",
    //   ],
    // },
  },
  data() {
    return {
      chartColor,
      min: 1,
      max: 100,
      // apexChatData,
      // rangePicker: ["2019-05-01", "2019-05-10"],
      seriesCustomize: [], // apiDashboard
      labelsCustomize: [],
      columChart: {
        series: [
          {
            name: "กำลังโหลดข้อมูล...",
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            stacked: true,
            toolbar: {
              show: false,
            },
          },
          // title: {
          //   text: this.titleText,
          //   align: "left",
          //   style: {
          //     fontSize: "16px",
          //   },
          // },
          colors: [],
          plotOptions: {
            bar: {
              columnWidth: "60%", // 100% ทำให้แท่งในกราฟติดกัน
              // borderRadius: 10, // ปรับปลายแท่งในกราฟมีความโค้ง
              distributed: false, // ปรับแท่งในกราฟแยกออกจากกันตาม series.data ถ้าเป็น false **มันจะมอง series.data เป็นก้อนเดียวกันทำให้กำหนดสีแต่ละแท่งไม่ได้
              horizontal: true, // ปรับให้มุมมองกราฟแท่งเป็นแถวตั้ง
              dataLabels: {
                // ปรับให้แสดงข้อความบนแท่งกราฟ กรณีไม่ใส่ default เป็น center (relate กับ chartOptions.dataLabels)
                position: "center", // top, center, bottom
              },
              // colors: { // ทำพื้นหลังกราฟแท่งแต่ละอัน
              //   backgroundBarColors: [
              //     // chartColors.column.bg,
              //     // chartColors.column.bg,
              //     // chartColors.column.bg,
              //     // chartColors.column.bg,
              //     // chartColors.column.bg,
              //   ],
              //   backgroundBarRadius: 10,
              // },
            },
          },
          dataLabels: {
            enabled: true,
            // offsetY: -20,
            style: {
              colors: [],
            },
          },
          // legend: {
          //   show: false,
          //   position: "bottom",
          //   fontSize: "10px",
          //   fontFamily: "Montserrat",
          //   horizontalAlign: "left",
          // },
          stroke: {
            show: false,
            colors: ["transparent"],
          },
          grid: {
            xaxis: {
              lines: {
                show: false,
              },
            },
          },
          xaxis: {
            labels: {
              show: false,
            },
            categories: [],
          },
          yaxis: {
            categories: [],
          },
          noData: {
            text: "ไม่พบข้อมูล",
            align: "center",
            verticalAlign: "middle",
            offsetX: 0,
            offsetY: 0,
            style: {
              color: undefined,
              fontSize: "18px",
              fontFamily: undefined,
            },
          },
          responsive: [
            {
              breakpoint: 1000,
              options: {
                plotOptions: {
                  bar: {
                    horizontal: false,
                  },
                },
                legend: {
                  position: "bottom",
                },
              },
            },
          ],
        },
      },
    };
  },
  mounted() {
    this.max = chartColor.color.length;

    if (this.issueName === "FASTTRACK_TRANSACTION_USER") {
      this.funcGetBarChart_SummaryFasttrackTransactionUser(this.filter);
    }
  },
  watch: {
    seriesCustomize: function(newVal, oldVal) {
      //console.log
      //   "@watch seriesCustomize newVal: ",
      //   newVal,
      //   " | oldVal: ",
      //   oldVal
      // );
      // this.updateBarChart();
    },
  },
  created() {
    window.addEventListener("resize", this.myEventHandler);
  },
  destroyed() {
    window.removeEventListener("resize", this.myEventHandler);
  },
  methods: {
    getChartColor(n) {
      this.columChart.chartOptions.colors = [];
      // this.columChart.chartOptions.dataLabels.style.colors = [];
      for (let i = 0; i < n; i++) {
        let idx = Math.floor(
          Math.random() * (this.max - this.min + 1) + this.min,
        );
        this.columChart.chartOptions.colors.push(this.chartColor.color[idx]);
        // this.columChart.chartOptions.dataLabels.style.colors.push(
        //   this.chartColor.color[idx],
        // );
      }
    },
    generatorColor(n) {
      this.columChart.chartOptions.colors = [];
      // this.columChart.chartOptions.dataLabels.style.colors = [];
      for (let i = 0; i < n; i++) {
        let hex = (Math.random() * 0xfffff * 1000000).toString(16);
        this.columChart.chartOptions.colors.push("#" + hex.slice(0, 6));
        // this.columChart.chartOptions.dataLabels.style.colors.push(
        //   "#" + hex.slice(0, 6),
        // );
      }

      // this.updateBarChart();
    },
    funcGetBarChart_SummaryFasttrackTransactionUser(obj) {
      const self = this;

      apiDashboard
        .GetBarChart_SummaryFasttrackTransactionUser(obj)
        .then((response) => {
          self.seriesCustomize = response.data.data.map((value) => value.total);
          self.labelsCustomize = response.data.data.map((value) => value.name);

          self.columChart.series[0].name = "จำนวนเข้าใช้งาน";
          self.columChart.series[0].data = self.seriesCustomize;
          self.columChart.chartOptions.xaxis.categories = self.labelsCustomize;
          if (self.seriesCustomize) {
            this.getChartColor(self.seriesCustomize.length);
          }
          this.updateBarChart();
        })
        .catch((error) => {
          //console.log("error", error);
        });
    },
    updateBarChart() {
      // redraw:
      // true = ทำการลบกราฟเดิม แล้วสร้างกราฟใหม่ทั้งหมด
      // false = อัพเดทเฉพาะส่วนที่เปลี่ยนแปลง

      // animate:
      // true = มี animation ตอนเปลี่ยนค่า
      // false = เปลี่ยนทันที ไม่มี animation

      // อัพเดทข้อมูล
      this.$refs["barChart"].updateSeries([
        {
          data: this.columChart.series,
        },
        false, // redraw
        true, // animate
      ]);

      // อัพเดทแกน ในที่นี้คือ แกน x
      // this.$refs["barChart"].updateOptions(
      //   {
      //     xaxis: {
      //       categories: apiData.map((v) => v.name),
      //     },
      //   },
      //   false, // redraw
      //   true, // animate
      // );

      this.$refs["barChart"].refresh();
    },
    myEventHandler(e) {
      this.$refs["barChart"].refresh();
    },
  },
};
</script>

<style lang="scss" scoped>
.chart-title {
  font-weight: 600;
  line-height: 1.3;
}

/* mobile */
@media (max-width: 576px) {
  .chart-title {
    font-size: 0.9rem;
  }
}

/* desktop */
@media (min-width: 992px) {
  .chart-title {
    font-size: 1.05rem;
  }
}

</style>
